import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useFacebookSignIn } from "../../hooks/useFacebookSignIn";
import facebookIcon from "../../assets/facebook.png";
import "./GoogleAuthButton.css";

const FacebookAuthButton = ({
  className = "",
  onSuccess,
  onError,
  children = "",
  affiliateCode = null,
  newsletter = false,
}) => {
  const { signIn: facebookSignIn } = useFacebookSignIn();
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const handleFacebookLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);
    try {
      const data = await facebookSignIn({
        affiliate: affiliateCode,
        newsletter,
      });

      setToken(data.access_token);
      localStorage.setItem("token", data.access_token);

      if (onSuccess) onSuccess(data);
      navigate("/shop");
    } catch (err) {
      console.error("FB ERROR:", err);

      const errorMessage = err?.message || "Facebook sign-in failed. Please try again.";

      if (typeof onError === "function") {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={`google-auth-btn ${className} ${loading ? "loading" : ""}`}
      onClick={handleFacebookLogin}
      disabled={loading}
      aria-label="Continue with Facebook"
    >
      <img src={facebookIcon} width="20" height="20" alt="Facebook Login" aria-hidden="true" />
      {children}
    </button>
  );
};

export default FacebookAuthButton;
